import numeral from 'numeral';

// ----------------------------------------------------------------------

type InputValue = string | number | null;

export function fNumber(number: InputValue) {
  return numeral(number).format();
}

// Pure utility: no React hooks. Optional currency override; otherwise tries localStorage('CURRENCY'), then defaults to '€'.
export function FCurrency(number: InputValue, currency?: string) {
  const hasNumber = number !== null && number !== undefined && `${number}` !== '';
  const format = hasNumber ? numeral(number as number).format('0,0.00') : '';

  let curr = currency;
  if (!curr && typeof window !== 'undefined') {
    const stored = window.localStorage.getItem('CURRENCY');
    curr = stored || undefined;
  }
  // Default currency symbol if none provided
  if (!curr) curr = '€';

  const formatted = result(format, '.00');
  return formatted ? `${formatted} ${curr}` : '';
}

export function fPercent(number: InputValue) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number: InputValue) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number: InputValue) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format: string, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}
